<template>
  <section>
    <el-container>
      <el-header>

        <Breadcrumb></Breadcrumb>

      </el-header>
      <el-main>

        <slot/>

      </el-main>
    </el-container>
  </section>
</template>

<script>
  import Breadcrumb from '@/components/Breadcrumb'

  export default {
    components: {
      Breadcrumb
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/MyManage.vue